import { appDisplayName, tenantLabel } from "modules/apps/tenants";
import type { MFCatalogItemSelectableResource } from "./catalogs";

// The link row carries its own (admin-set) name; the tenant fields ride on the
// selectable resource it points at.
export const catalogLinkName = (
  link: MFCatalogItemSelectableResource,
  name: string = link.name,
): string => {
  const { tenantName, sharesDomain } = link.selectableResource ?? {};
  return appDisplayName({ name, tenantName, sharesDomain });
};

/**
 * The tenant line for a card that keeps the admin-set title: null unless the
 * link points at an app whose domain another app row shares.
 */
export const catalogLinkTenant = (
  link: Pick<MFCatalogItemSelectableResource, "selectableResource">,
): string | null =>
  link.selectableResource ? tenantLabel(link.selectableResource) : null;

/** The distinct tenants across a catalog item's links, for its card. */
export const catalogItemTenants = (
  links: Pick<MFCatalogItemSelectableResource, "selectableResource">[],
): string | null => {
  const tenants = new Set(
    links.map(catalogLinkTenant).filter((t): t is string => t !== null),
  );
  return tenants.size ? Array.from(tenants).join(", ") : null;
};
